import { WorkOffersCategories } from "../modules";

export const WorkOffersCategoriesPage = () => {
  return <WorkOffersCategories />;
};
